<div id="dashboard-counts" class="w-100">
    <div class="stat-page">
        <div style="display: flex; justify-content: space-between; align-items:center; position: relative;"
            class="title-st">
            <p>احصائيات المستشفي </p>
            <div class="search-area">

                <div class="input-group input-group-sm">
                    <input class="form-control" placeholder="{{ 'FROMDATE' | translate }}"
                        [(ngModel)]="dashBoard.fromDate" ngbDatepicker #FDDFrom="ngbDatepicker" />
                    <div class="input-group-addon" (click)="FDDFrom.toggle()">
                        <i class="fa fa-calendar"></i>
                    </div>
                </div>
                <div class="input-group input-group-sm">
                    <input class="form-control" placeholder="{{ 'TODATE' | translate }}" [(ngModel)]="dashBoard.toDate"
                        ngbDatepicker #FDDTO="ngbDatepicker" />
                    <div class="input-group-addon" (click)="FDDTO.toggle()">
                        <i class="fa fa-calendar"></i>
                    </div>
                </div>
                <button (click)="onSearchClick()" style="
              border-radius: 39px;
              text-align: left;
              color: green;
              background: lightblue;
              margin-right: 10px;
          ">
                    {{'Search'| translate}}
                </button>
            </div>
            <div>
                <button (click)="refersh()" style="
                border-radius: 39px;
                text-align: left;
                color: green;
                background: lightblue;
            ">
                    {{'Refrsh'| translate}}
                </button>
                <button (click)="sendTimePeriod(1)" style="
                border-radius: 39px;
                text-align: left;
                color: green;
                background: lightblue;
                margin-inline: 15px;
            ">
                    {{"LAST WEEK"| translate}}
                </button>
                <button (click)="sendTimePeriod(2)" style="
                border-radius: 39px;
                text-align: left;
                color: green;
                background: lightblue;
                margin-inline: 15px;
            ">
                    {{"LAST MONTH"| translate}}
                </button>
                <button (click)="sendTimePeriod(3)" style="
                border-radius: 39px;
                text-align: left;
                color: green;
                background: lightblue;
            ">
                    {{"LAST YEAR"| translate}}
                </button>
            </div>
        </div>
        <div class="st-content" *ngFor="let _cat of categories;index as k;">
            <fieldset class="p-3 border border-gray bg-white col-fieldset">
                <legend>

                    {{translate.currentLang == 'ar' ? _cat.categoryNameAr : _cat.categoryNameEn}}

                </legend>
                <div *ngIf="_cat.categoryShape==1" class="row m-0">

                    <div class="col-md-3" *ngFor="let count of categoryFiter(_cat['categoryCode']);index as i;">
                        <div class="stat-container">
                            <div class="stat-num">
                                <span>{{count.cValueStr}}</span>
                            </div>
                            <div class="stat-name">{{translate.currentLang == 'ar'? count.nameAr: count.nameEn}}</div>
                        </div>
                    </div>
                </div>
                <div>
                    <div *ngIf="_cat.categoryShape==2" class="card-body row">
                        <div class="col-3">
                            <!-- <span class="main-span"
                             [ngClass]="{'left-main-span': translate.currentLang != 'ar', 'right-main-span': 
                             translate.currentLang == 'ar'}">
                                <div >
                                    {{totalSum}}
                                </div>
                                <div> {{translate.currentLang == 'ar'? tableTitleAr : tableTitleAr}} </div>
                            </span> -->

                            <!-- <ngx-donutchart [slices]="slices | arrayfilter: 'categoryCode' : _cat['categoryCode']"
                                [size]="size" [innerRadius]="innerRadius">
                            </ngx-donutchart> -->
                            <ngx-charts-pie-chart [view]="view" [scheme]="colorScheme" [results]="slices"
                                [doughnut]="true">
                            </ngx-charts-pie-chart>
                        </div>
                        <div class="col-6">
                            <ul class="list-group list-group-flush">
                                <li style="cursor: pointer;"
                                    class="list-group-item d-flex justify-content-between align-items-center px-2">

                                    <span style="font-weight: bold; width: 60%;">
                                        {{ translate.currentLang == 'ar' ? _cat['typeAr'] : _cat['typeEn']}}
                                    </span>

                                    <span *ngIf="_cat.numLblAr =='' || _cat.numLblAr ==undefiend   "
                                        style="width: 20%; font-weight: bold; ">
                                        {{ 'DEALCOUNT' | translate}}
                                    </span>
                                    <span *ngIf="_cat?.numLblAr && _cat.numLblAr.trim() !== ''"
                                        style="width: 20%; font-weight: bold; ">
                                        {{ translate.currentLang == 'ar' ? _cat['numLblAr'] : _cat['numLblEn']}}
                                    </span>
                                </li>
                            </ul>
                            <ul class="list-group list-group-flush"
                                *ngFor="let job of slices| arrayfilter: 'categoryCode' : _cat['categoryCode']  ; let i = index">

                                <li style="cursor: pointer;"
                                    class="list-group-item d-flex justify-content-between align-items-center px-2">
                                    <span [ngStyle]="{'color':job.color} " style="width: 60%; font-size: 20px;">
                                        {{job.name}}
                                    </span>

                                    <span [ngStyle]="{'color':job.color,'width': '20%' ,'font-size': '20px'}">
                                        {{job.value}}
                                    </span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </fieldset>

        </div>
    </div>
</div>